// extracted by mini-css-extract-plugin
export default {"messages":"gameView_messages__0wbVs"};